module.exports = __webpack_public_path__ + "static/media/laf_yellow.52e16ab8.png";